import { render, staticRenderFns } from "./workflow_canvas_connector_ghost.vue?vue&type=template&id=2d20eb7d&scoped=true&"
import script from "./workflow_canvas_connector_ghost.vue?vue&type=script&lang=js&"
export * from "./workflow_canvas_connector_ghost.vue?vue&type=script&lang=js&"
import style0 from "./workflow_canvas_connector_ghost.vue?vue&type=style&index=0&id=2d20eb7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20eb7d",
  null
  
)

export default component.exports